var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46 46",
    style: {
      enableBackground: "new 0 0 46 46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.status-success-svg .st0{fill:#17B2A7;}\n\t.status-success-svg .st1{fill:#D22544;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "status-success-svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,0C10.3,0,0,10.3,0,23c0,12.7,10.3,23,23,23s23-10.3,23-23C46,10.3,35.7,0,23,0z M19.5,33.4L8.8,22.7 l1.4-1.4l9.3,9.3l16.3-17.3l1.5,1.4L19.5,33.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuccess);
export default __webpack_public_path__ + "static/media/status-success.8e0a485ec6107ea5c9c12edd92dbbb98.svg";
export { ForwardRef as ReactComponent };